import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, FileDown, Loader2 } from "lucide-react";
import { BACKEND_URL } from "../../lib/api";
import { mk, money } from "../../lib/market";

export default function MarketOrderSuccess() {
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [o, setO] = useState(null);
  const [tries, setTries] = useState(0);
  useEffect(() => {
    if (!sid || o?.payment_status === "paid" || tries > 15) return undefined;
    const t = setTimeout(() => mk.get(`/market/orders/status/${sid}`).then((r) => setO(r.data)).finally(() => setTries((n) => n + 1)), tries ? 2000 : 0);
    return () => clearTimeout(t);
  }, [sid, o, tries]);
  const paid = o?.payment_status === "paid";
  return (
    <div className="min-h-screen bg-[var(--bg)] flex items-center justify-center p-6">
      <div className="bg-white border border-[var(--line)] rounded-3xl p-10 max-w-md text-center" data-testid="market-order-status">
        {paid ? <CheckCircle2 className="w-12 h-12 text-[var(--gold)] mx-auto" /> : <Loader2 className="w-12 h-12 text-[var(--gold)] mx-auto animate-spin" />}
        <p className="font-serif text-3xl mt-4" data-testid="market-order-title">{paid ? "It's yours!" : tries > 15 ? "Still confirming…" : "Confirming payment…"}</p>
        {o && <p className="text-[var(--muted)] mt-2">{o.title} · {money(o.amount)}</p>}
        {o?.items?.length > 1 && <ul className="text-sm text-left mt-4 space-y-1" data-testid="market-order-items">{o.items.map((i) => <li key={i.listing_id} className="flex justify-between gap-3"><Link to={`/market/item/${i.listing_id}`} className="truncate hover:text-[var(--gold)]">{i.title}</Link><span>{money(i.amount)}</span></li>)}</ul>}
        {paid && <p className="text-sm mt-4">We've told {o.items?.length > 1 ? "each seller" : "the seller"} and emailed your receipt. Message them to arrange pickup or shipping.</p>}
        {tries > 15 && !paid && <p className="text-sm mt-4 text-[var(--muted)]">Your bank may still be processing. Refresh this page in a minute.</p>}
        <div className="flex flex-wrap gap-2 justify-center mt-6">
          {paid && o.invoice && <a href={`${BACKEND_URL}${o.invoice.pdf_url}`} target="_blank" rel="noreferrer" className="btn-gold !py-2.5" data-testid="market-order-invoice"><FileDown className="w-4 h-4" /> Invoice {o.invoice.number}</a>}
          {paid && <Link to="/account/orders" className="btn-outline-gold !py-2.5" data-testid="market-order-track">Track orders</Link>}
          {o && <Link to={o.items?.length > 1 ? "/market/inbox" : `/market/item/${o.listing_id}`} className="btn-outline-gold !py-2.5" data-testid="market-order-item">Message seller</Link>}
          <Link to="/market" className="btn-outline-gold !py-2.5" data-testid="market-order-browse">Keep browsing</Link>
        </div>
      </div>
    </div>
  );
}
